import React, { useEffect, useState } from "react";

export default function SidebarCategories({ selectedLocations, setSelectedLocations }) {
  const [categories, setCategories] = useState([]);
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/destinationwithcount")
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setCategories(data.data);
        }
      })
      .catch((err) => {
        console.log("API Error:", err);
      });
  }, []);

  const toggleCategory = (cat) => {
    setOpenCategory(openCategory === cat ? null : cat);
  };

  const handleLocationChange = (location) => {
    setSelectedLocations((prevSelected) => {
      if (prevSelected.includes(location)) {
        return prevSelected.filter((loc) => loc !== location);
      } else {
        return [...prevSelected, location];
      }
    });
  };

  return (
    <div>
      <ul className="sidebar-list">
        {categories.map((cat, index) => (
          <li key={index} className="sidebar-category-dropdown">
            <label className="containerss">
              <input type="checkbox" />
              <span className="checkmark" />
              <strong>{cat.category.toUpperCase()}</strong>
            </label>

            <i
              className={`bi bi-caret-right-fill sidebar-category-icon ${
                openCategory === cat.category ? "active" : ""
              }`}
              onClick={() => toggleCategory(cat.category)}
            />

            {/* Sub Locations */}
            {openCategory === cat.category && (
              <ul className="subcategory-list">
                {cat.locations.map((loc) => (
                  <li key={loc.id} className="subcategory-item">
                    <label className="containerss">
                      <input
                        type="checkbox"
                        checked={selectedLocations.includes(loc.name)}
                        onChange={() => handleLocationChange(loc.name)}
                      />
                      <span className="checkmark"></span>
                      {loc.name} ({loc.package_count})
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}